import { createContext } from 'react';
import { ConsentSnackbarContextType } from './consent-snackbar-types';

export const ConsentSnackbarContext = createContext<ConsentSnackbarContextType>(
  undefined as any
);
